var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"py-1 px-2",attrs:{"size":"sm","variant":"primary","href":_vm.link,"target":"_blank"}},[_c('b-img',{staticStyle:{"height":"1rem"},attrs:{"src":_vm.iconURL}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }